
import React, { useEffect } from "react";
import { MDBDataTable } from "mdbreact";
const Table = (props) => {
  const selectRows = () => {
    document.querySelector('table').addEventListener('click', function (e) {

      var closestCell = e.target.closest('tr'), // identify the closest td when the click occured
        activeCell = e.currentTarget.querySelector('tr.selected'); // identify the already selected td

      closestCell.classList.add('selected'); // add the "selected" class to the clicked td
      if (activeCell) activeCell.classList.remove('selected'); // remove the "selected" class from the previously selected td

    })
  }
  useEffect(() => {
    selectRows();
  }, []);
  const data = {
    columns: props.columns,
    rows: props.Rows
  };
  return (
    <div className="wrapper wrapper-content animated fadeInRight">
      <div className="row">
        <div className="col-lg-12">
          <div className="ibox ">
            <div className="ibox-content">
              <div className="table-responsive">
                <MDBDataTable exportToCSV={true} displayEntries={false} btn={true} striped responsiveLg btn exportToCSV bordered hover data={data} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
}
export default Table;